import { Spinner } from "@/components/ui/Spinner";
import { Text } from "@/components/ui/Typography";
import type { ReactNode } from "react";
import { FeedbackIcon } from "./FeedbackIcon";
import type { FeedbackVariant } from "./variants";

export type ToastVariant = FeedbackVariant | "loading";

/**
 * Body of every toast: icon badge on the left, optional bold title above the
 * message. Lives apart from `toast.tsx` so that module can export the
 * `showToast` API without mixing components and non-components in one file,
 * which breaks Vite's fast refresh.
 */
export function ToastBody({
  variant,
  title,
  message,
}: {
  variant: ToastVariant;
  title?: string;
  message: ReactNode;
}) {
  return (
    <div className="flex items-center gap-3 py-0.5">
      {variant === "loading" ? (
        <Spinner size="md" tone="primary" />
      ) : (
        <FeedbackIcon variant={variant} size="md" />
      )}
      <div className="flex min-w-0 flex-col">
        {title && (
          <Text size="sm" weight="bold" tone="default">
            {title}
          </Text>
        )}
        <Text as="div" size="sm" weight="medium" leading="snug" tone="muted">
          {message}
        </Text>
      </div>
    </div>
  );
}
